<script>
import {mapState} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import EverywhereList from "@/components/MainSearch/SearchResult/EverywhereList.vue";
import ProposalListAll from "@/components/MainSearch/SearchResult/Proposal/ProposalListAll.vue";
import ProposalList from "@/components/MainSearch/SearchResult/Proposal/ProposalList.vue";
import OpinionListAll from "@/components/MainSearch/SearchResult/Opinion/OpinionListAll.vue";
import OpinionList from "@/components/MainSearch/SearchResult/Opinion/OpinionList.vue";
import ArgumentListAll from "@/components/MainSearch/SearchResult/Argument/ArgumentListAll.vue";
import ArgumentList from "@/components/MainSearch/SearchResult/Argument/ArgumentList.vue";
import MemberList from "@/components/MainSearch/SearchResult/MemberList.vue";
import OrganisationList from "@/components/MainSearch/SearchResult/OrganisationList.vue";
import ForumList from "@/components/MainSearch/SearchResult/ForumList.vue";
import SourceList from "@/components/MainSearch/SearchResult/SourceList.vue";

export default {
  name: "MainSearchResultList",
  components: {
    EverywhereList,
    ProposalListAll,
    ProposalList,
    OpinionListAll,
    OpinionList,
    ArgumentListAll,
    ArgumentList,
    MemberList,
    OrganisationList,
    ForumList,
    SourceList
  },
  computed: {
    ...mapState(mainSearchStore, [
      'searchParams',
      'hasSearchParamControls',
      'multipleSearch',
    ]),
    searchType() {
      return this.searchParams.searchType;
    },
  }
}
</script>

<template>
  <div class="main-search-result-list" :class="{'main-search-result-list--has-controls': hasSearchParamControls}">
    <everywhere-list v-if="searchType === 'ALL'"/>
    <template v-else-if="searchType === 'PROPOSAL'">
      <proposal-list-all v-if="multipleSearch"/>
      <proposal-list v-else/>
    </template>
    <template v-else-if="searchType === 'OPINION'">
      <opinion-list-all v-if="multipleSearch"/>
      <opinion-list v-else/>
    </template>
    <template v-else-if="searchType === 'ARGUMENT'">
      <argument-list-all v-if="multipleSearch"/>
      <argument-list v-else/>
    </template>
    <member-list v-else-if="searchType === 'MEMBER'"/>
    <organisation-list v-else-if="searchType === 'ORGANIZATION'"/>
    <forum-list v-else-if="searchType === 'FORUM'"/>
    <source-list v-else-if="searchType === 'SOURCE'"/>
  </div>
</template>

<style lang="scss" scoped>
.main-search-result-list {
  max-width: 600px;
  padding-top: 45px;
  &--has-controls {
    padding-top: 85px;
  }
}
</style>